<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <h5 class="font-medium election-title">📄 Distribution of Consumer Goods</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <form [formGroup]="targetForm" (ngSubmit)="GetConsumerGoods()">
                            <div class="row align-items-end">

                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                                    <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                                        <option value="">--Select--</option>
                                        <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                                            {{ circle?.sCircleName }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                                        class="text-danger small">
                                        Circle office is required
                                    </div>
                                </div>
                                <!-- Block Office -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="blockOffice">
                                        <option value="" selected>--Select--</option>
                                        <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                            {{ circle?.sBlockName }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                                        class="text-danger small">
                                        block Office is required
                                    </div>
                                </div>

                                <!-- Financial Year -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Financial/Reporting Year <span
                                            class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="financialYear">
                                        <option value="">--Select--</option>
                                        <option *ngFor="let years of financialYears" [ngValue]="years">
                                            {{ years?.financialYear }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                                        class="text-danger small">
                                        Financial year is required
                                    </div>
                                </div>

                                <!-- Submit -->
                                <div class="col-lg-12 text-end">
                                    <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                                        Get Report
                                    </button>
                                </div>

                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <div class="d-flex align-items-center justify-content-between">
                        <h5 class="font-medium m-0">📄Report</h5>
                        <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal"
                            data-bs-target="#ConsumerGoodsDistributionDataModal" (click)="addData()"
                            *ngIf="showButton && (this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)">+ Add
                            Distribution Goods {{currentMonth?.name}}</button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-bordered" style="min-width:768px">
                            <tbody>
                                <!-- Header Rows -->
                                <tr class="texture font-size-12">
                                    <th class="text-center" style="width: 3%" rowspan="2">Sr. No.</th>
                                    <th rowspan="2">Month</th>
                                    <th class="text-center" colspan="2">Urban</th>
                                    <th class="text-center" colspan="2">Rural</th>
                                    <th rowspan="2" class="text-center" style="width:3%">Action</th>
                                </tr>
                                <tr class="texture font-size-12">
                                    <th class="text-right">Controlled (<i class="fa fa-inr fa-mr-0"></i> in lacs)</th>
                                    <th class="text-right">Non Controlled (<i class="fa fa-inr fa-mr-0"></i> in lacs)
                                    </th>
                                    <th class="text-right">Controlled (<i class="fa fa-inr fa-mr-0"></i> in lacs)</th>
                                    <th class="text-right">Non Controlled (<i class="fa fa-inr fa-mr-0"></i> in lacs)
                                    </th>
                                </tr>

                                <!-- Data Rows -->
                                <tr *ngFor="let row of rows; let i = index">
                                    <td class="text-center">{{ i + 1 }}.</td>
                                    <td>{{ getMonthName(row.dataMonth) }}, {{
                                        getYearFromFinancialYear(row.financialYear, row.dataMonth) }}</td>

                                    <td class="text-right">{{ row.urbanControlled | number: '1.2-2' }}</td>
                                    <td class="text-right">{{ row.urbanNonControlled | number: '1.2-2' }}</td>
                                    <td class="text-right">{{ row.ruralControlled | number: '1.2-2' }}</td>
                                    <td class="text-right">{{ row.ruralNonControlled | number: '1.2-2' }}</td>

                                    <td>
                                        <div class="d-flex align-items-center gap-1">
                                            <ng-container
                                                *ngIf="!row.isVerified && this.UserDetails?.roleId !==1; else verifiedBlock">
                                                <button type="button" class="btn btn-primary btn-sm"
                                                    title="Click to Edit" (click)="editRow(row)">
                                                    <i class="bi bi-pencil-square"></i>
                                                </button>
                                                <button type="button" class="btn btn-success btn-sm"
                                                    title="Click to Verify" *ngIf="this.UserDetails?.roleId ==13"
                                                    data-bs-toggle="modal" data-bs-target="#verifyConfirmModal"
                                                    (click)="setDeleteIndex(row?.id)">
                                                    <i class="bi bi-clipboard2-check"></i>
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm"
                                                    title="Click to Delete" data-bs-toggle="modal"
                                                    data-bs-target="#deleteConfirmModal"
                                                    (click)="setDeleteIndex(row?.id)">
                                                    <i class="bi bi-trash3"></i>
                                                </button>
                                            </ng-container>

                                            <!-- Verified State -->
                                            <ng-template #verifiedBlock>
                                                <button type="button" class="btn btn-primary btn-sm"
                                                    [title]="'Verified on ' + (row.verifiedOn ? (row.verifiedOn | date:'dd/MM/yyyy hh:mm:ss a') : '')">
                                                    <i class="bi bi-lock"></i>
                                                </button>
                                            </ng-template>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- Delete Confirmation Modal -->
                        <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                            aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to delete ?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="cancelDelete()">Cancel</button>
                                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                            aria-label="Close" (click)="DeleteConsumerData(deleteIndex)">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- verify Confirmation Modal -->
                        <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                            aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to Verify?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="this.deleteIndex = 0;">Cancel</button>
                                        <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                                            aria-label="Close" (click)="verifyConsumerData(deleteIndex)">Verify</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <!-- Modal -->
                <div class="modal fade" id="ConsumerGoodsDistributionDataModal" data-bs-backdrop="static"
                    data-bs-keyboard="false" tabindex="-1" aria-labelledby="ConsumerGoodsDistributionDataModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl ">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title fs-5" id="ConsumerGoodsDistributionDataModalLabel">Add Consumer
                                    Goods Distribution Data</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">

                                <form [formGroup]="distributionForm">
                                    <div class="row">
                                        <!-- Financial Year -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">Financial/Reporting Year <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="financialYear">
                                                <option value="">--Select--</option>
                                                <option *ngFor="let years of financialYears" [ngValue]="years">
                                                    {{ years?.financialYear }}
                                                </option>
                                            </select>
                                            <div *ngIf="distributionForm.get('financialYear')?.touched && distributionForm.get('financialYear')?.invalid"
                                                class="text-danger small">
                                                Financial year is required
                                            </div>
                                        </div>


                                        <!-- Block Office -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">Block Office <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="blockOffice">
                                                <option value="" selected>--Select--</option>
                                                <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                                    {{ circle?.sBlockName }}
                                                </option>
                                            </select>
                                            <div *ngIf="distributionForm.get('blockOffice')?.touched && distributionForm.get('blockOffice')?.invalid"
                                                class="text-danger small">
                                                block Office is required
                                            </div>
                                        </div>


                                        <!-- During Month -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">During Month <span
                                                    class="text-danger">*</span></label>
                                            <!-- <input class="form-control" type="month" formControlName="duringMonth" placeholder="e.g., May 2025" /> -->
                                            <select class="form-control" formControlName="dataMonth">
                                                <option value="" selected>--Select Month--</option>
                                                <option *ngFor="let month of months" [value]="month?.iMonthId">
                                                    {{ month?.sMonthName }}
                                                </option>
                                            </select>

                                            <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="distributionForm.get('dataMonth')?.touched && distributionForm.get('dataMonth')?.invalid">
                                                    This field is required
                                                </span>
                                            </div>
                                        </div>


                                        <!-- Table with Inputs -->
                                        <div class="col-lg-12">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>S.No.</th>
                                                            <th>Distribution Location</th>
                                                            <th>Controlled (₹ in lacs)</th>
                                                            <th>Non-Controlled (₹ in lacs)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <!-- Row 1: Urban -->
                                                        <tr>
                                                            <td>1</td>
                                                            <td>Urban</td>
                                                            <td>
                                                                <div class="input-group">
                                                                    <span class="input-group-text">₹</span>
                                                                    <input type="text" class="form-control"
                                                                        formControlName="urbanControlled"
                                                                        placeholder="Please Fill the Data" />
                                                                    <span class="input-group-text">lacs</span>
                                                                </div>
                                                                <div class="text-danger small"
                                                                    style="min-height: 1.25rem;">
                                                                    <span
                                                                        *ngIf="distributionForm.get('urbanControlled')?.touched && distributionForm.get('urbanControlled')?.hasError('required')">
                                                                        This field is required
                                                                    </span>
                                                                    <span
                                                                        *ngIf="distributionForm.get('urbanControlled')?.touched && distributionForm.get('urbanControlled')?.hasError('pattern')">
                                                                        Please enter a valid number
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="input-group">
                                                                    <span class="input-group-text">₹</span>
                                                                    <input type="text" class="form-control"
                                                                        formControlName="urbanNonControlled"
                                                                        placeholder="Please Fill the Data" />
                                                                    <span class="input-group-text">lacs</span>
                                                                </div>
                                                                <div class="text-danger small"
                                                                    style="min-height: 1.25rem;">
                                                                    <span
                                                                        *ngIf="distributionForm.get('urbanNonControlled')?.touched && distributionForm.get('urbanNonControlled')?.hasError('required')">
                                                                        This field is required
                                                                    </span>
                                                                    <span
                                                                        *ngIf="distributionForm.get('urbanNonControlled')?.touched && distributionForm.get('urbanNonControlled')?.hasError('pattern')">
                                                                        Please enter a valid number
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <!-- Row 2: Rural -->
                                                        <tr>
                                                            <td>2</td>
                                                            <td>Rural</td>
                                                            <td>
                                                                <div class="input-group">
                                                                    <span class="input-group-text">₹</span>
                                                                    <input type="text" class="form-control"
                                                                        formControlName="ruralControlled"
                                                                        placeholder="Please Fill the Data" />
                                                                    <span class="input-group-text">lacs</span>
                                                                </div>
                                                                <div class="text-danger small"
                                                                    style="min-height: 1.25rem;">
                                                                    <span
                                                                        *ngIf="distributionForm.get('ruralControlled')?.touched && distributionForm.get('ruralControlled')?.hasError('required')">
                                                                        This field is required
                                                                    </span>
                                                                    <span
                                                                        *ngIf="distributionForm.get('ruralControlled')?.touched && distributionForm.get('ruralControlled')?.hasError('pattern')">
                                                                        Please enter a valid number
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="input-group">
                                                                    <span class="input-group-text">₹</span>
                                                                    <input type="text" class="form-control"
                                                                        formControlName="ruralNonControlled"
                                                                        placeholder="Please Fill the Data" />
                                                                    <span class="input-group-text">lacs</span>
                                                                </div>
                                                                <div class="text-danger small"
                                                                    style="min-height: 1.25rem;">
                                                                    <span
                                                                        *ngIf="distributionForm.get('ruralNonControlled')?.touched && distributionForm.get('ruralNonControlled')?.hasError('required')">
                                                                        This field is required
                                                                    </span>
                                                                    <span
                                                                        *ngIf="distributionForm.get('ruralNonControlled')?.touched && distributionForm.get('ruralNonControlled')?.hasError('pattern')">
                                                                        Please enter a valid number
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                    (click)="closeModel()">Close</button>
                                <button type="button" class="btn btn-primary" (click)="onSubmit()">Save</button>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </div>

    </div>
</div>